import * as prismic from "@prismicio/client";

// Define your Prismic repository name
const repositoryName = "tiacomp";

// Initialize the Prismic client
export const client = prismic.createClient(repositoryName, {
  accessToken:
    "MC5aMVZoTkJFQUFDNEFTdUFr.77-9YiTvv70w77-977-977-9RwAW77-9Ku-_ve-_vRDvv70a77-9Ze-_ve-_ve-_vW3vv71ccW3vv71B77-977-9", // Optional if the repository is private
});
